<template>
  <div class="bg-fff pa-t-16 pa-l-56 pa-b-20 width920px user-message">
    <div class="titles-right font-style">我的展映</div>
    <div
      class="ma-t-20 flex"
      v-for="(item, index) in dataList"
      :key="index"
      @click="toDetail(item)"
    >
      <img :src="item.ActivityImage" class="img_230 img_cover" />
      <div class="ma-l-10 width70">
        <span class="fon-18 weight500 bold">{{ item.ActivityName }}</span>
       
        <br />
        <div class="flex ma-t-10" style="align-item: center">
          <div >
            <span class="ma-r-30 w-50 d-i-b" >订单单号：{{ item.SN }}  </span>
          </div>
          <div>
            <span class="ma-r-30 w-50 d-i-b">订单金额：{{ item.PayAmount }} </span>
          </div>
        </div>
        <div class="flex ma-t-10" style="align-item: center">
          <div >
            <span class="ma-r-30 w-50 d-i-b" >订单状态：{{ item.Status }}  </span>
          </div>
          <div v-if="item.PayTime!=''">
            <span class="ma-r-30 w-50 d-i-b">支付时间：{{ item.PayTime }} </span>
          </div>
        </div>
      </div>
    </div>
   
    <Empty  class="height50" :isShow="dataList.length == 0"></Empty>
    <div class="t-center ma-t-20">
      <el-pagination
        @current-change="handleCurrentChange"
        :hide-on-single-page="true"
        :current-page.sync="queryList.pageIndex"
        :page-size="queryList.pageSize"
        layout="prev, pager, next, jumper"
        :total="totals"
      ></el-pagination>
    </div>
    <el-dialog
      :visible.sync="ticketshow"
      :show-close="false"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      width="600"
    >
      <el-carousel
        :interval="4000"
        class="carousel d-none d-sm-block"
      >
        <el-carousel-item class="caritem"  v-for="(item,index) in ticket.item" :key="index">
          <div class="ticketmain">
            <div class="flex f-center">
              <img :src="ticket.img" class="ticketimg" />
            </div>
            <div class="flex f-center">
              <div class="ticketcontent">
                <div class="tic1">
                  <span class="ticketname">{{ ticket.title }}</span>
                </div>
                <div class="tic2">时间 ：{{ ticket.time }}</div>
                <div class="tic2">地点 ：{{ ticket.address }}</div>
                <div class="flex f-center">
                  <div>
                    <img src="../img/ticketcode.png" class="ticketcode" />
                  </div>
                </div>
                <div class="tick2">票码：{{ item.code }}</div>
              </div>
            </div>
          </div>
        </el-carousel-item>
         
      </el-carousel>

    </el-dialog>
  </div>
</template>

<script>
//import { myParticipationActivity } from '../api'

import { myShowing } from '../api'
export default {
  name: 'myactivity',
  data() {
    return {
      dataList: [],
      tabIndex: 0, //0 =》资讯收藏，1=》方案收藏
      queryList: {
        pageIndex: 1,
        pageSize: 10,
        source: 'web'
      },
      totals: 0,
      ticketshow: false,
     ticket:{
      title:'',
      img:'',
      time:'',
        address:'',
      item:[{
        code:''
      }]
     }
    }
  },
  mounted() {
    this.loadDataList()
  },
  methods: {
    myticket(index) {
      var project = this.dataList[index]
      var ticket={
        title:project.Name,
        img:project.MainImage,
        time:project.StartTime + '-' + project.EndTime,
        address: project.Address,
        item:[]
      }
      for (let index = 0; index < project.Ticket.length; index++) {
        ticket.item.push({code:project.Ticket[index].Code})
        
      } 
      this.ticket=ticket
      this.ticketshow = true
      console.log(1)
    },
    // 当前页改变时触发
    handleCurrentChange(e) {
      this.queryList.pageIndex = e
      this.loadDataList()
    },
    loadDataList() {
      //myParticipationActivity(this.queryList).then((res) => {
      myShowing(this.queryList).then((res) => {
        this.dataList = res.data.Data.List
        this.totals = res.data.Data.TotalCount
      })
    },
    //查看详情
    toDetail(item) {
      this.$router.push({
        path: '/vod/detail',
        query: {
          id: item.ActivityId,
          siteId: item.SiteId
        }
      })
    }
  }
}
</script>

<style  lang="scss" scoped >
    @import "../../css/bootstrap.min.css";
    @import "../../css/commons.css";
.carousel{
  height: 700;
}
.caritem{
  display: flex;
  height: 700;
  justify-content: center;
}
.tick2 {
  text-align: center;
  font-size: 18;
  font-weight: bold;
  margin-top: 5;
}
.tic1 {
  margin-left: 40;
  margin-top: 30;
}
.tic2 {
  margin-left: 40;
  margin-top: 8;
  font-size: 18;
}
.ticketname {
  font-size: 24;
  font-weight: bold;
}
.f-center {
  justify-content: center;
}
.ticketmain {
  background-image: url(../img/back000.png);
  height: 681;
  width: 485;
  background-position: center;
  background-size: cover;
}
.ticketcode {
  width: 136;
  height: 136;
  margin-top: 10;
}
.ticketimg {
  width: 448;
  height: 252;
  margin-top: 20;
}
.ticketcontent {
  background-image: url(../img/backborder.png);
  height: 338;
  width: 445;
  background-position: center;
  background-size: cover;
  margin-top: 50;
}
.btn-support-2 {
  padding: 6px 26px;
  background: #fb004d;
  display: inline-block;
  color: #fff;
  cursor: pointer;
}
.titles-right:before {
  content: '|';
  display: inline-block;
  width: 4px;
  height: 19px;
  background: #234775;
  color: #234775;
  border-radius: 2px;
  margin-right: 8px;
}
.width920px {
  width: 920px;
}
.font-style {
  font-size: 14px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
}
.tab-active {
  border-bottom: 2px solid #234775;
}

.img_230 {
  width: 230px;
  height: 149px;
}
</style>